module.exports = __webpack_public_path__ + "static/lepes1-c0b1fb7eb65bb80396943999bf4d130c.png";